export default {
  storeCurrency(currency) {
    localStorage.setItem("pah.cur", currency);
  },
  getCurrency() {
    return localStorage.getItem("pah.cur");
  },
  storeTimezone(tz) {
    localStorage.setItem("pah.tz", JSON.stringify(tz));
  },
  getTimezone() {
    var val = localStorage.getItem("pah.tz");
    return val ? JSON.parse(val) : null;
  }
}



// WEBPACK FOOTER //
// ./src/services/localdata.service.js